import "../../css/ClusterListings.css";
import { Box } from "@mui/material";
import { Helmet } from "react-helmet";
import LinearProgress from "components/LinearProgress";
import AlertDialog from "components/AlertDialog";
import ClusterDetailDisplay from "components/ClusterDetailCard/ClusterDetailDisplay";
import { TrialClusterCard } from "components/ClusterDetailCard/TrialCluster/TrialClusterCard";
import { ClusterListingHeader } from "./ClusterListingHeader";
import { NoClusterContent } from "./NoClusterContent";
import { useClusterListings } from "./useClusterListing";
import { isWorkerHostingEnvironment } from "utils/saastypes";
export default function ClusterListings() {
  const [
    {
      filterPopupState,
      sortPopupState,
      clusterListFetching,
      confirmDelete,
      filteredEnvironments,
      currentProfile,
      confirmEnableDelete,
      clusterData,
      filters,
      sortingCriteria,
    },
    {
      toggleFilter,
      refetchAllClusters,
      setConfirmDelete,
      triggerDeletionFlow,
      triggerEnableClusterDeletion,
      setConfirmEnableDelete,
      handleSearchValueChange,
      setSortingCriteria,
      setFilters,
    },
  ] = useClusterListings();

  // Worker Hosting (CLOUD-1193): a worker environment points at its parent, so the reverse
  // relationship is derivable from the unfiltered listing — no extra request needed to mark
  // the parents. Derived from clusterData, not filteredEnvironments, so the mark survives
  // search and filtering hiding the worker entry itself.
  const parentClusterIdsWithWorkers = new Set(
    clusterData
      ?.filter(isWorkerHostingEnvironment)
      .map(({ parentClusterId }) => parentClusterId)
  );

  return (
    <>
      <Helmet>
        <title>Orkes Cloud - Cluster Listing</title>
      </Helmet>
      {clusterListFetching && <LinearProgress />}

      <AlertDialog
        textTitle={""}
        textContent={`Please confirm if you want to proceed to delete this cluster (${confirmDelete.clusterName}). This action cannot be undone. All data will be permanently lost.`}
        open={confirmDelete.confirmDelete}
        setOpen={() =>
          setConfirmDelete({ confirmDelete: false, clusterName: undefined })
        }
        handleConfirm={() =>
          triggerDeletionFlow(true, confirmDelete.clusterName)
        }
      />
      <AlertDialog
        textTitle={""}
        textContent={`Please confirm if you want to enable deletion for cluster (${confirmEnableDelete.clusterName}).`}
        open={confirmEnableDelete.confirmDelete}
        setOpen={() =>
          setConfirmEnableDelete({
            confirmDelete: false,
            clusterName: undefined,
          })
        }
        handleConfirm={() =>
          triggerEnableClusterDeletion(true, confirmEnableDelete.clusterName)
        }
      />
      <ClusterListingHeader
        filteredEnvironments={filteredEnvironments}
        refetchAllClusters={refetchAllClusters}
        sortPopupState={sortPopupState}
        setSortingCriteria={setSortingCriteria}
        clusterData={clusterData}
        filters={filters}
        filterPopupState={filterPopupState}
        setFilters={setFilters}
        handleSearchValueChange={handleSearchValueChange}
        sortingCriteria={sortingCriteria}
        toggleFilter={toggleFilter}
      />

      {filteredEnvironments?.length !== 0 && (
        <Box id="cluster-lists-cards-wrapper">
          {filteredEnvironments?.map((custEnv) => {
            const isTrialTypeCluster = custEnv.environmentType === "TRIAL";
            const maybeEngineeringRole =
              currentProfile && currentProfile === "ENGINEERING";

            return isTrialTypeCluster && !maybeEngineeringRole ? (
              <TrialClusterCard
                key={`${custEnv.id}-paper`}
                skipMiddleBar={false}
                custEnv={custEnv}
                refetchAllClusters={refetchAllClusters}
              />
            ) : (
              <ClusterDetailDisplay
                deleteClusterMethod={triggerDeletionFlow}
                enableClusterDeletionMethod={triggerEnableClusterDeletion}
                key={`${custEnv.id}-paper`}
                skipMiddleBar={false}
                custEnv={custEnv}
                hasHostedWorkers={parentClusterIdsWithWorkers.has(custEnv.id)}
              />
            );
          })}
        </Box>
      )}
      {filteredEnvironments?.length === 0 && (
        <NoClusterContent clusters={clusterData} />
      )}
    </>
  );
}
